import { render, staticRenderFns } from "./CompositeRecordDetail.vue?vue&type=template&id=d47095a0&scoped=true"
import script from "./CompositeRecordDetail.vue?vue&type=script&lang=js"
export * from "./CompositeRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./CompositeRecordDetail.vue?vue&type=style&index=0&id=d47095a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d47095a0",
  null
  
)

export default component.exports